export default __webpack_public_path__ + "static/review-934c00426fc2183547d995f2e3eb838f.svg";